// src/SubmitButton.js

import React, { memo } from 'react';
import './SubmitButton.css';

const SubmitButton = memo(({ status }) => {
  const isSent    = status === 'success';
  const isSending = status === 'sending';

  return (
    <div className="submit-wrap">
      <button
        type="submit"
        disabled={isSending}
        aria-label={isSent ? 'Message submitted' : isSending ? 'Sending message' : 'Submit message'}
        aria-live="polite"
        className={"submit-btn" + (isSent ? " is-sent" : "") + (isSending ? " is-sending" : "")}
      >
        <div className="submit-btn__outline" />

        {/* Default state */}
        <div className="submit-btn__state submit-btn__state--default">
          <div className="submit-btn__icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="1em" width="1em">
              <g style={{ filter: 'url(#shadow)' }}>
                <path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor" />
              </g>
              <defs>
                <filter id="shadow">
                  <feDropShadow floodOpacity="0.5" stdDeviation="0.6" dy={1} dx={0} />
                </filter>
              </defs>
            </svg>
          </div>
          <p>
            <span style={{'--i': 0}}>S</span>
            <span style={{'--i': 1}}>u</span>
            <span style={{'--i': 2}}>b</span>
            <span style={{'--i': 3}}>m</span>
            <span style={{'--i': 4}}>i</span>
            <span style={{'--i': 5}}>t</span>
          </p>
        </div>

        {/* Sent state */}
        <div className="submit-btn__state submit-btn__state--sent">
          <div className="submit-btn__icon">
            <svg stroke="black" strokeWidth="0.5px" width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g style={{ filter: 'url(#shadow)' }}>
                <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="currentColor" />
                <path d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z" fill="currentColor" />
              </g>
            </svg>
          </div>
          <p>
            <span style={{'--i': 5}}>S</span>
            <span style={{'--i': 6}}>u</span>
            <span style={{'--i': 7}}>b</span>
            <span style={{'--i': 8}}>m</span>
            <span style={{'--i': 9}}>i</span>
            <span style={{'--i': 10}}>t</span>
            <span style={{'--i': 11}}>t</span>
            <span style={{'--i': 12}}>e</span>
            <span style={{'--i': 13}}>d</span>
          </p>
        </div>

      </button>
    </div>
  );
});

SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;